import React, { useState, useCallback } from "react";
import { View, Text } from "react-native";
import { globalImport } from "../common/globalImports";
import YoutubePlayerReact from "../screens/home/childComponents/youtubePlayerReact";

const LiveView = ({ videoKey, isHashtag }) => {
    const [playing, setPlaying] = useState(true);

    const onStateChange = useCallback((state) => {
        if (state === "ended") {
            setPlaying(false);
        }
    }, []);

    const togglePlaying = useCallback(() => {
        setPlaying((prev) => !prev);
    }, []);

    return (
        <View style={{ borderRadius: 8 }}>
            <YoutubePlayerReact
                hTTVideoKey={globalImport.isWeb ? 'https://www.youtube.com/watch?v=' + videoKey : videoKey }
                onStateChange={onStateChange}
                isHashtag={isHashtag}
            />
        </View>
    );
};

export default LiveView;
